import { Controller, useForm } from 'react-hook-form';
import { useLoginStore } from '@lib/store';
import { cn } from '@shared/utils';
import type { LoginResponse } from '@shared/api';
import { Button, ErrorMessage, Input, Radio } from '@shared/widgets';

interface IForm {
  deviceId: string;
  factor: 'passcode';
  passcode: string;
}

interface DUOFormProps {
  className?: string;
  devices: LoginResponse['devices'];
  token: LoginResponse['temp_token'];
}

export const DUOForm = (props: DUOFormProps) => {
  const loginStore = useLoginStore();

  const { control, formState, handleSubmit } = useForm<IForm>({
    defaultValues: { deviceId: props.devices?.[0]?.device || '', factor: 'passcode', passcode: '' },
  });

  const submitHandler = async (data: IForm) => await loginStore.twoFactor({ factor: data.factor, passcode: data.passcode, temp_token: props.token! });

  const multipleDevices = props.devices && props.devices.length > 1;
  return (
    <div>
      <form className='flex flex-col' onSubmit={handleSubmit(submitHandler)}>
        <div className='relative flex items-center justify-start' />
        {multipleDevices && (
          <div className='my-6'>
            <div className='mb-4 text-center text-[#766750]'>SELECT YOUR DEVICE</div>
            <div>
              {props.devices!.map((device, idx) => (
                <div key={device.device} className={cn('p-4 pr-1', idx && 'border-t border-t-[#443e35]')}>
                  <Controller
                    name='deviceId'
                    control={control}
                    render={({ field: { value, onChange } }) => (
                      <Radio
                        right
                        fullWidth
                        name='device'
                        disabled={formState.isSubmitting}
                        value={device.device}
                        checked={value === device.device}
                        onChange={(value) => onChange(value)}
                      >
                        {device.display_name}
                      </Radio>
                    )}
                  />
                </div>
              ))}
            </div>
          </div>
        )}
        <div>
          <div className='mb-10'>
            <Controller
              name='passcode'
              control={control}
              rules={{ required: 'This field is required' }}
              render={({ field, fieldState: { error } }) => (
                <>
                  <Input {...field} className='h-[48px]' variant='outlined' placeholder='Masterkey passcode' />
                  <ErrorMessage text={error?.message} />
                </>
              )}
            />
          </div>
          <Button className='!h-[56px]' fullWidth type='submit' disabled={!formState.isValid || formState.isSubmitting}>
            Submit
          </Button>
        </div>
      </form>
    </div>
  );
};
